import { PlatformChartType } from '@data/_generated-api/platform-api/models/platform-chart-type';
import { PlatformSharedChartDto } from '@data/_generated-api/platform-api/models/platform-shared-chart-dto';
import { HdBodygraphChartPreset } from '../bodygraph/hd-bodygraph.models';

/**
 * Chart delen via link (spec docs/superpowers/specs/2026-10-20-chart-share-analyse.md).
 * Eén token per chart; null = niet gedeeld.
 */

/** Doel van de deeldialoog (manager-rij of de actieve chart op de pagina). */
export interface HdChartShareTarget {
  id: string;
  name: string;
  /** Bepaalt de uitleg in de dialoog: enkel een standaardchart is door de kijker op te slaan. */
  type: PlatformChartType;
  shareToken: string | null;
}

/** Nieuwe deelstatus na maken of stoppen. */
export interface HdChartShareChange {
  id: string;
  shareToken: string | null;
}

/** Gedeelde chart zoals het anonieme endpoint hem levert: meta + geparsed document. */
export interface HdSharedChartResult {
  meta: PlatformSharedChartDto;
  preset: HdBodygraphChartPreset;
}

/** Deellink: hash-routing, dus `{origin}/#/shared/{token}`. */
export function buildHdChartShareUrl(token: string, origin = window.location.origin): string {
  return `${origin}/#/shared/${token}`;
}

/**
 * UPAM-feature "Charts delen": zonder deze feature bestaan de deelknoppen niet
 * (shortcutbalk, manager, gedeelde-charts-overzicht). Zelfde GUID als
 * `AppConstants.Features.ShareChartsFeatureId` in de backend; toekenning in UPAM
 * per gebruikersgroep. Een deellink bekijken blijft voor iedereen open.
 */
export const SHARE_CHARTS_FEATURE_ID = 'dee10000-0000-4000-8000-0000dee10000';

/** Waarom een gedeelde chart niet geladen kon worden. */
export type HdSharedChartLoadErrorKind = 'invalid' | 'tooManyRequests';

/**
 * Laadfout van een deellink: `invalid` (onbekend of ingetrokken token) of
 * `tooManyRequests` (anonieme limiet van de link bereikt: even wachten).
 */
export class HdSharedChartLoadError extends Error {
  constructor(readonly kind: HdSharedChartLoadErrorKind, message: string) {
    super(message);
    this.name = 'HdSharedChartLoadError';
  }
}
